var map = {
	"./_base-badge.vue": "fdfd",
	"./_base-box.vue": "79a8",
	"./_base-button.vue": "8339",
	"./_base-common-paragraph.vue": "71c5",
	"./_base-competitors.vue": "4f9f",
	"./_base-form.vue": "eba6",
	"./_base-global-header.vue": "65da",
	"./_base-global-intro.vue": "059a",
	"./_base-global-logos.vue": "558c",
	"./_base-global-section.vue": "6ac3",
	"./_base-headline.vue": "f073",
	"./_base-hero-titles.vue": "bee4",
	"./_base-hero.vue": "fdeb",
	"./_base-intro.vue": "d3cc",
	"./_base-label.vue": "9681",
	"./_base-link.vue": "cbd4",
	"./_base-logo.vue": "b7c5",
	"./_base-modal.vue": "80b6",
	"./_base-obstacles.vue": "be6b",
	"./_base-payment.vue": "a4c5",
	"./_base-search.vue": "404d",
	"./_base-section-background.vue": "244e",
	"./_base-section-hero-media.vue": "ac2e",
	"./_base-section-intro.vue": "66af",
	"./_base-section-media.vue": "6c5d",
	"./_base-section-paragraph.vue": "ab0c",
	"./_base-section-quote.vue": "e830",
	"./_base-section-subsection.vue": "6a7a",
	"./_base-section-table-row.vue": "ea78",
	"./_base-section-table.vue": "e436",
	"./_base-section.vue": "be25",
	"./_base-slide-arrow.vue": "f741",
	"./_base-spinner.vue": "1603",
	"./_base-subsection-wrapper.vue": "93bf",
	"./_base-super-headline.vue": "4640",
	"./_base-transition.vue": "50e2",
	"./_base-typography-overview-section-headline.vue": "8f16",
	"./_base-typography-overview-section-intro.vue": "5b09",
	"./_base-typography-overview-section-subheadline.vue": "2c39",
	"./_base-video.vue": "040a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b526";